import {
  ADMISSION_CREATE_REQUEST,
  ADMISSION_CREATE_SUCCESS,
  ADMISSION_CREATE_FAIL,

  ADMISSION_GET_ALL_REQUEST,
  ADMISSION_GET_ALL_SUCCESS,
  ADMISSION_GET_ALL_FAIL,

  ADMISSION_GET_ONE_REQUEST,
  ADMISSION_GET_ONE_SUCCESS,
  ADMISSION_GET_ONE_FAIL,

  ADMISSION_UPDATE_REQUEST,
  ADMISSION_UPDATE_SUCCESS,
  ADMISSION_UPDATE_FAIL,

  ADMISSION_DELETE_REQUEST,
  ADMISSION_DELETE_SUCCESS,
  ADMISSION_DELETE_FAIL,

  CLEAR_ERRORS,
} from "../constants/admissionConstants";


export const createAdmissionReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMISSION_CREATE_REQUEST:
      return { loading: true };

    case ADMISSION_CREATE_SUCCESS:
      return { loading: false, admission: action.payload };

    case ADMISSION_CREATE_FAIL:
      return { loading: false, error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};


export const getAllAdmissionsReducer = (state = { admissions: [] }, action) => {
  switch (action.type) {
    case ADMISSION_GET_ALL_REQUEST:
      return { loading: true };

    case ADMISSION_GET_ALL_SUCCESS:
      return { loading: false, admissions: action.payload };

    case ADMISSION_GET_ALL_FAIL:
      return { loading: false, error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};


export const getAdmissionByIdReducer = (state = { admission: {} }, action) => {
  switch (action.type) {
    case ADMISSION_GET_ONE_REQUEST:
      return { loading: true };

    case ADMISSION_GET_ONE_SUCCESS:
      return { loading: false, admission: action.payload };

    case ADMISSION_GET_ONE_FAIL:
      return { loading: false, error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};


export const updateAdmissionReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMISSION_UPDATE_REQUEST:
      return { loading: true };

    case ADMISSION_UPDATE_SUCCESS:
      return { loading: false, updated: true, admission: action.payload };

    case ADMISSION_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};


export const deleteAdmissionReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMISSION_DELETE_REQUEST:
      return { loading: true };

    case ADMISSION_DELETE_SUCCESS:
      return { loading: false, deleted: true, message: action.payload };

    case ADMISSION_DELETE_FAIL:
      return { loading: false, error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};
